import React, {useState, useEffect} from "react"
import Header from "./header/Header"
import RegistrationKey from "./registrationKey/RegistrationKey"
import GameLanding from "./gameLanding/GameLanding"
import PasswordCheck from "./passwordCheck/PasswordCheck"
import MainSection from "./main/MainSection"
import Footer from "./footer/Footer"
import EndingText from "./EndingText"
import Debrief from "./Debrief"
import downloadData from "./main/downloadModule/downloadData"

function App() {
    const [loggedIn, setLoggedIn] = useState(false)
    const [userKey, setUserKey] = useState("")
    const [playerData, setPlayerData] = useState("")
    const [playerPrint, setPlayerPrint] = useState(true)
    const [pageId, setPageId] = useState(0)
    const [playerStatus, setPlayerStatus] = useState([
        {},
        { status: "locked" }, // PART ONE
        { status: "locked" }, 
        { status: "locked" },
        { status: "locked" },
        { status: "locked" }, // PART FIVE
        {},
        {}
    ])
    const [pageContent, setPageContent] = useState("")
    const [gameEndId] = useState(6)
    const [gameDebriefId] = useState(7)
    const [showClues, setShowClues] = useState(false)
    const [memoryGame, setMemoryGame] = useState(false)
    const [memoryGameTime, setMemoryGameTime] = useState(60)
    const [updateClues, setUpdateClues] = useState(false)
    const [addClueOption, setAddClueOption] = useState("")
    const [removeClueOption, setRemoveClueOption] = useState("")
    
    function logIn(state, data, key) {
        setLoggedIn(state)
        setPlayerData(data)
        setUserKey(key)
    }
    
    function logOut() {
        localStorage.removeItem("localKey")
        document.location.reload(true)
    }
    
    useEffect(() => {
        if (loggedIn) {
            const storedKey = localStorage.getItem("localKey")
            if (!storedKey || storedKey !== userKey) {
                localStorage.setItem("localKey", userKey)
            }
            
            if (playerData.activated_at === null) {
                const productDetails = {
                    product_id: 1,
                    product_key: userKey, 
                    api_url: "purchase/activate",
                    activate: true
                }

                contactDatabase(productDetails)
                    .then((response) => {
                        console.log('API response', response)
                        setPlayerData(response.data)

                    })

                function contactDatabase(data) {
                  return fetch('/.netlify/functions/hello', {
                    body: JSON.stringify(data),
                    method: 'POST'
                  }).then(response => {
                    return response.json()
                  })
                }
            }
            
            const updateStatus = playerStatus.map((value, index) => {
                if (index < playerData.stage && index > 0) {
                    return {status: "complete"}
                } else if (index >= playerData.stage && index < 6) {
                    return {status: "locked"}
                } else {
                    return {}
                }
            })
            
            setPlayerStatus(updateStatus)
            setPlayerPrint(true)
            
            playerData.stage >= gameEndId ? setPageId(gameDebriefId) : setPageId(0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loggedIn])
    
    function callBackCluesUpdated() {
        setUpdateClues(false)
        setAddClueOption("")
        setRemoveClueOption("")
    }
    
    function callBackRevealClues(addName, removeName) {
        setAddClueOption(addName)
        setRemoveClueOption(removeName)
    }
    
    useEffect(() => {
        if (addClueOption !== "") { setUpdateClues(true) }
    },[addClueOption])
    
    function handleClick(pageTarget) {
        if (pageId < gameDebriefId) { setPageId(pageTarget) }
    }
    
    useEffect(() => {
        if (pageId >= gameDebriefId) {
            setPageContent( <Debrief />)
        } else if (pageId === gameEndId) {
            console.log()
            setPageContent( <EndingText />) 
            setTimeout(() => handleClick(gameDebriefId), 4000)
        } else if (pageId > 0 && playerStatus[pageId].status !== "locked") {
            setPageContent( <MainSection currentPage={pageId} callBackPage={handleClick} gameEndId={gameEndId} callBackGameUpdate={callBackGameUpdate} timeLimit={memoryGameTime} callBackRevealClues={callBackRevealClues} handleDownload={handleDownload} callBackPartComplete={partComplete} partStatus={playerStatus} playerPrint={playerPrint} />)
        } else if (pageId > 0 && playerStatus[pageId].status === "locked") {
            setPageContent( <PasswordCheck currentPage={pageId} callBackUnlock={unlockPage} gameEndId={gameEndId} />) 
        } else if (loggedIn) {
            setPageContent( <GameLanding callBackPage={handleClick} handleDownload={handleDownload} playerPrint={playerPrint} callBackLogOut={logOut} playerStage={playerData.stage}/> )
        } else {
            setPageContent( <RegistrationKey callBackLogIn={logIn}/>)                   
        }
                           
        if (pageId !== 4) { setMemoryGame(false) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[playerStatus, pageId, memoryGameTime, gameEndId, gameDebriefId, loggedIn, playerPrint])
    
    function unlockPage(update) {
        let localArray = []
        if (localArray.length > 0) {localArray.length = 0}
        localArray = playerStatus
        localArray[pageId] = { status: "unlocked" }
        setPlayerStatus(localArray)
        setPageContent( <MainSection currentPage={pageId} callBackPage={handleClick} gameEndId={gameEndId} callBackGameUpdate={callBackGameUpdate} timeLimit={memoryGameTime} callBackRevealClues={callBackRevealClues} handleDownload={handleDownload} callBackPartComplete={partComplete} partStatus={playerStatus} playerPrint={playerPrint} />)
    }
                       
    function partComplete(update) {
        let localArray = []
        if (localArray.length > 0) {localArray.length = 0}
        localArray = playerStatus
        localArray[pageId] = { status: "complete" }
        setPlayerStatus(localArray)
        if (pageId < gameEndId) {
            setPageContent( <MainSection currentPage={pageId} callBackPage={handleClick} gameEndId={gameEndId} callBackGameUpdate={callBackGameUpdate} timeLimit={memoryGameTime} callBackRevealClues={callBackRevealClues} handleDownload={handleDownload} callBackPartComplete={partComplete} partStatus={playerStatus} playerPrint={playerPrint} />)
        }
        
        console.log("player stage = " + playerData.stage)
        if (pageId === playerData.stage || playerData.stage === 0 || pageId >= gameEndId)
        {
             const productDetails = {
                    product_id: 1,
                    product_key: userKey,
                    stage: (pageId+1),
                    api_url: "purchase/update/stage"
                }

            contactDatabase(productDetails)
                .then((response) => {
                    console.log('API response', response)
                    setPlayerData(response.data)
                })

            function contactDatabase(data) {
              return fetch('/.netlify/functions/hello', {
                body: JSON.stringify(data),
                method: 'POST'
              }).then(response => {
                console.log("API CALL SENT")
                return response.json()
              })
            }
        }
    }
                       
    function callBackTimer(clue) {
        const updatedTime = memoryGameTime + 15
        if (memoryGame) {
                if (clue < 3) {
                setMemoryGameTime(updatedTime)
            } else {
                setMemoryGameTime(undefined)             
            }
            setPageContent( <MainSection currentPage={pageId} callBackPage={handleClick} gameEndId={gameEndId} callBackGameUpdate={callBackGameUpdate} timeLimit={memoryGameTime} callBackRevealClues={callBackRevealClues} handleDownload={handleDownload} callBackPartComplete={partComplete} partStatus={playerStatus} playerPrint={playerPrint} />)
        }
    }
        
    function callBackGameUpdate() {
        setMemoryGame(true)
    }
    
     useEffect(() => {
        if (pageId === gameEndId) {
            document.getElementById("endText").style.opacity = "100%"
            partComplete(true)
        }
         
        playerStatus[pageId].status === "unlocked" ? setShowClues(true) : setShowClues(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageContent, gameEndId])
     
    function handleDownload(event) {
        const downloadSource = downloadData[pageId].source
        window.open(downloadSource, '_blank')
    }

    return(
        <div>
            {pageId !== gameEndId ? <Header currentPage={pageId} changePage={handleClick} loggedIn={loggedIn}/> : undefined}                
            {pageContent}
            <Footer currentPage={pageId} clueSystem={showClues} gameEndId={gameEndId} callBackTimer={callBackTimer} callBackCluesUpdated={callBackCluesUpdated} updateClues={updateClues} addClueOption={addClueOption} removeClueOption={removeClueOption}/>
        </div>
    )
}

export default App